module.exports = __webpack_public_path__ + "static/media/02290035-LDU0wSgs.f06df9f9.JPG";